import { useState, useEffect } from 'react';
import { useApiData } from '../../components/GetData';


// Custom hook to get status of a specific progress key
export const useProgressStatus = (progressKey) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const [isLoading, setIsLoading] = useState();
  console.log("Using progress key:", progressKey);


  // Use your existing API hook
  const { data: apiProgressData, loading: apiLoading, fetchData } = useApiData("application/getAppProgress");
  // Fetch progress data on mount
  useEffect(() => {
    fetchData();
  }, []);

  // Update local state when API data arrives
  useEffect(() => {
    if (apiProgressData) {

      // Check if our specific progress key is true in the API response
      const completed = apiProgressData[progressKey] === 1;
      console.log("Progress Status for", progressKey, ":", completed);
      setIsCompleted(completed);

      setIsLoading(false);
    }
  }, [apiProgressData, progressKey]);

  // Function to manually mark as completed (for optimistic updates)
  const markAsCompleted = () => {
    setIsCompleted(true);
  };

  // Function to manually mark as incomplete
  const markAsIncomplete = () => {
    setIsCompleted(false);
  };


  // Refresh the status from API
  const refreshStatus = async () => {
    setIsLoading(true);
    await fetchData();
  };

  return {
    isCompleted,
    isLoading: apiLoading || isLoading,
    markAsCompleted,
    markAsIncomplete,
    refreshStatus,
  };
};

export default useProgressStatus;